import { gql } from '@apollo/client';

export const readAllActiveUsers = gql`
  {
    readAllActiveUsers {
      id
      adId
      name
      LastLoggedInAt
    }
  }
`;
